import { render } from "./MemberSyncPage.vue?vue&type=template&id=0c236bf0&scoped=true"
import script from "./MemberSyncPage.vue?vue&type=script&lang=js"
export * from "./MemberSyncPage.vue?vue&type=script&lang=js"

import "./MemberSyncPage.vue?vue&type=style&index=0&id=0c236bf0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c236bf0"]])

export default __exports__